import { Action, getModule, Module, Mutation, VuexModule } from "vuex-module-decorators";
import store from "@/store";
@Module({
    namespaced: true,
    name: "appState",
    store,
    dynamic: true,
})
class appState extends VuexModule {
    sendDelete = false;
    sendCancel = false;
    sendUpdate = false;
    sendSubmit = false;
    sendProxy = false;
    sendApplyFilters = false;
    sendProxyWithParam = false;
    oldApplyFilters = false;
    success = false;

    @Mutation
    oldSetApplyFilters(value: boolean) {
        this.oldApplyFilters = value
    }

    @Mutation
    setApplyFilters(value: boolean) {
        this.sendApplyFilters = value;
    }

    @Mutation
    setSubmit(value: boolean) {
        this.sendSubmit = value;
    }

    @Mutation
    setUpdate(value: boolean) {
        this.sendUpdate = value
    }

    @Mutation
    setCancel(value: boolean) {
        this.sendCancel = value;
    }

    @Mutation
    setDelete(value: boolean) {
        this.sendDelete = value;
    }

    @Mutation
    setProxy(value: boolean) {
        this.sendProxy = value;
    }

    @Mutation
    setProxyWithParam(value: boolean) {
        this.sendProxyWithParam = value;
    }

    @Mutation
    setSuccess(value: boolean) {
        this.success = value;
    }



}
export const AppStateStore = getModule(appState);
